
const digest = 'fe059860ed0cef722fc2c7fd98d5304564a648a2c3b432a43ea873f45911eda9';
const classes = {"toothWrapper":"_toothWrapper_19xmn_1","extracted":"_extracted_19xmn_9","extractedText":"_extractedText_19xmn_27"};
const css = `._toothWrapper_19xmn_1 {
  padding: 10px 0;
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
}

._extracted_19xmn_9 {
  outline: 3px dotted #e13830;
  border-radius: 20px;
  position: relative;
}
._extracted_19xmn_9:not(:last-child)::after {
  content: url("/dist/icons/dent/extraction.svg");
  position: absolute;
  display: inline-block;
  left: 50%;
  bottom: -9px;
  height: 18px;
  width: 18px;
  overflow: hidden;
  margin-left: -9px;
  z-index: 1;
}

._extractedText_19xmn_27 {
  position: relative;
}
._extractedText_19xmn_27:before, ._extractedText_19xmn_27:after {
  left: 50%;
  transform: translateX(-50%);
  position: absolute;
  text-align: center;
  font-size: 12px;
  line-height: 16px;
  font-weight: 700;
  content: var(--extracted-text);
  color: #e13830;
  text-transform: uppercase;
}
._extractedText_19xmn_27:before {
  top: -8px;
}
._extractedText_19xmn_27:after {
  bottom: -8px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  